import * as React from "react";
import { Button } from "@mui/material";

interface IProps {
    filterItems: any[],
    currentState: string,
    onChanged: Function,
    rightAlignButtons?: boolean
}
interface IState {

}

export class SideBySideButton extends React.Component<IProps, IState> {
    constructor(props, context) {
        super(props, context);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.min !== this.props.currentState;
    }

    componentDidUpdate(props) {
        // Desired operations: ex setting state
    }

    onChanged = (p) => {
        this.props.onChanged(p);
    }

    render = () => {
        const { filterItems, currentState, rightAlignButtons } = this.props;
        const buttonWidth = 96/filterItems.length

        //Create the side by side option buttons. The width is determined by the number of them - current logic is if there are less than 4 buttons 
        //they go side by side, more than four 
        //we put four to a row 
        return (
                    <div style={{display:"flex", flexWrap: 'wrap', textAlign: {rightAlignButtons} ? "right" : "center", alignItems: {rightAlignButtons} ? "right" : null, justifyContent: {rightAlignButtons} ? "right" : null, width: "100%", padding: "5px"}}>
                        {filterItems.map(a => <Button key={a} style={{display: "inlineBlock",
                                                                            backgroundColor: (a == currentState ? "#1e88e5" : "#A9A9A9"),
                                                                            width: (buttonWidth >= 25 ? (buttonWidth)+"%" : "23%"),
                                                                            maxHeight: "50px",
                                                                            fontSize: (window.innerWidth < 400 ? 10 : null),
                                                                            color: "white",
                                                                            margin: "2px"
                                                                        }}
                            onClick={_ => this.onChanged(a)}
                            > {a} </Button>
                        )}
                    </div>
        );
    }
}